import React, { useState, useEffect } from 'react';
import { HDate, gematriya } from '@hebcal/core';
import {useTranslation} from 'react-i18next';

const HebrewDate = () => {
    const [dateDisplay, setDateDisplay] = useState('');
    const {i18n} = useTranslation();

    const hebrewMonths = {
        'Tishrei': 'בתשרי',
        'Cheshvan': 'בחשוון',
        'Kislev': 'בכסלו',
        'Tevet': 'בטבת',
        'Sh\'vat': 'בשבט',
        'Shvat': 'בשבט',
        'Adar': 'באדר',
        'Adar I': 'באדר א\'',
        'Adar II': 'באדר ב\'',
        'Nisan': 'בניסן',
        'Iyyar': 'באייר',
        'Sivan': 'בסיוון',
        'Tamuz': 'בתמוז',
        'Av': 'באב',
        'Elul': 'באלול'
    };

    const formatHebrewYear = (year) => {
        return gematriya(year % 1000);
    };

    const getOrdinalNum = (number) => {
        const suffixes = ['th', 'st', 'nd', 'rd'];
        const lastDigit = number % 10;
        const lastTwoDigits = number % 100;
        const suffix = (lastTwoDigits >= 11 && lastTwoDigits <= 13) ? 'th' : suffixes[lastDigit] || 'th';
        return number + suffix;
    };

    const formatDate = (date) => {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${month} ${getOrdinalNum(day)} ${year}`;
    };

    const updateDate = () => {
        const now = new Date();
        const hebrewDateObj = new HDate(now);

        const day = hebrewDateObj.getDate();
        let monthEng = hebrewDateObj.getMonthName();
        const year = hebrewDateObj.getFullYear();
        const isLeapYear = HDate.isLeapYear(year);

        monthEng = monthEng.replace("'", "");

        // קבלת שם החודש בעברית
        const monthHeb = hebrewMonths[monthEng] || monthEng;

        // התאמת אדר א' ואדר ב' לשנים מעוברות
        let adjustedMonthHeb = monthHeb;
        let adjustedMonthEng = monthEng;
        if (isLeapYear && (monthEng === 'Adar' || monthEng === 'Adar I')) {
            adjustedMonthHeb = hebrewMonths['Adar I'];
            adjustedMonthEng = 'Adar I';
        } else if (isLeapYear && monthEng === 'Adar II') {
            adjustedMonthHeb = hebrewMonths['Adar II'];
            adjustedMonthEng = 'Adar II';
        }

        if (i18n.language === 'en') {
            const hebrewFormatted = `${adjustedMonthEng} ${getOrdinalNum(day)}, ${year}`;
            const gregorianFormatted = formatDate(now);
            setDateDisplay(`${hebrewFormatted} (${gregorianFormatted})`);
        } else {
            const hebrewDay = gematriya(day);
            setDateDisplay(`${hebrewDay} ${adjustedMonthHeb} ה'${formatHebrewYear(year)}`);
        }
    };

    useEffect(() => {
        updateDate();

        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        const timeUntilMidnight = midnight - now;

        const timeout = setTimeout(() => {
            updateDate();
            setInterval(updateDate, 24 * 60 * 60 * 1000);
        }, timeUntilMidnight);

        return () => clearTimeout(timeout);
    }, [i18n.language]); // עדכון גם כאשר השפה משתנה

    return (
        <div className="text-right">
            <div className="text-xl font-bold font-heebo">{dateDisplay}</div>
        </div>
    );
};

export default HebrewDate;